import { render, staticRenderFns } from "./GeneralSettingsTaxesVatInPrice.vue?vue&type=template&id=a82ca948&"
import script from "./GeneralSettingsTaxesVatInPrice.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsTaxesVatInPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports